import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  Input,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { ControlContainer, NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseFpxControlComponent } from "@fpx/core";

@Component({
  selector: "fpx-checkbox",
  templateUrl: "./fpx-checkbox.component.html",
  styleUrls: ["./fpx-checkbox.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FpxCheckboxComponent),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class FpxCheckboxComponent extends BaseFpxControlComponent {
  @Input() textPosition: 'after' | 'before' = 'after';

  constructor(
    _controlContainer: ControlContainer,
    changeDetectorRef: ChangeDetectorRef
  ) {
    super(_controlContainer, changeDetectorRef);
  }

  override doPreInit(): void {
    
  }
  onCheckBoxChange($event) {
    if ($event.checked) {
      this.formControl.setValue(1);
    } else {
      this.formControl.setValue(0);
    }
    // Direct setValue bypasses the forms value-accessor pipeline, so touched/dirty are not set.
    // Mark them so *ngIf="invalid && touched" (and similar) works for checkbox errors.
    this.formControl.markAsDirty();
    this.formControl.markAsTouched();
  }
}
